module.exports = __webpack_public_path__ + "static/media/openFullscreenW.a03c1fa1.png";